import * as React from 'react'

// this helps for setting root font size for rem values
export default function useTypeThemeClass(applyTheme: boolean) {
  React.useEffect(() => {
    if (applyTheme) {
      document.documentElement.classList.add('q221-body')
    }
  })
}